import * as THREE from 'three'

import Sizes from './utils/Sizes'
import Resources from './utils/Resources'
import Time from './utils/Time'
import Camera from './Camera'
import Renderer from './Renderer'

import World from './World'

let instance = null
const canvas = document.querySelector('.webgl')

export default class Experience {
  constructor() {
    if (instance) {
      return instance
    }
    instance = this

    window.experience = this

    this.canvas = canvas
    this.app = document.querySelector('.globe')
    this.closeButton = document.querySelectorAll('[data-name="close-pop-up"]')
    this.popUp = document.querySelector('[data-name="pin-pop-up"]')
    this.sizes = new Sizes()
    this.time = new Time()
    this.scene = new THREE.Scene()
    this.resources = new Resources()
    this.camera = new Camera()
    this.renderer = new Renderer()
    this.world = new World()

    // Resize Event
    this.sizes.on('resize', () => {
      this.onResize()
    })

    // Time Event
    this.time.on('tick', () => {
      this.update()
    })

    this.addEventListeners()
  }

  onResize() {
    this.canvas.width = this.sizes.width
    this.canvas.height = this.sizes.height
    if (this.camera && this.camera.onResize) {
      this.camera.onResize()
    }
    if (this.renderer && this.renderer.onResize) {
      this.renderer.onResize()
    }
  }

  update() {
    if (this.world && this.world.update) {
      this.world.update()
    }
    if (this.camera && this.camera.update) {
      this.camera.update()
    }
    if (this.renderer && this.renderer.update) {
      this.renderer.update()
    }
  }

  addEventListeners() {
    if (this.world && this.world.addEventListeners) {
      this.world.addEventListeners()
    }
  }
}
